const skills = ['JavasScript', 'Python', 'Google Maps API', 'React Native', 'React JS'];

export default skills;
